export default __webpack_public_path__ + "static/support-sponsor-gff-859dbcfa14f9747239a95a2b997000ec.png";